__webpack_require__.p = "/themes/glory-frontoffice/assets/";